<template>
    <div :class="class" v-if="showField()">
        <FieldReadonly :value="getValue()" :label="label" :format="format" />
    </div>
</template>

<script>
import FieldReadonly from "@/components/common/form/FieldReadonly.vue";

export default {
    components: {
        FieldReadonly,
    },
    props: {
        user: {
            type: Object,
            default: null,
        },
        field_name: {
            type: String,
            required: true
        },
        label: {
            type: String,
            default: ''
        },
        format: {
            type: String,
        },
        class: {
            type: String,
            default: ''
        }
    },
    data() {
        return {};
    },
    methods: {
        getValue() {
            return this.user?.features?.[this.field_name] || this.user?.[this.field_name] || null;
        },
        showField() {
            return (!this.$root.features?.users?.featureLoginHiddenFields || !this.$root.features?.users?.featureLoginHiddenFields.some(field => field == this.field_name))
                && (this.$root.features?.users?.featureFields?.some(field => field.name === this.field_name)
                    || Object.keys(this.user).includes(this.field_name));
        }
    }
};
</script>
